import { takeLatest, putResolve } from 'redux-saga/effects';
import {
  setGuidedOptionFilter,
  initGuidedOptionFilter,
} from '../actions';
import safeSaga from './safeSaga';

function* setGuidedOptionFilters(action) {
  yield putResolve(setGuidedOptionFilter({ filterType: action.payload.type, data: action.payload }));
}

export function* setGuidedOptionFiltersSaga() {
  yield takeLatest(initGuidedOptionFilter.toString(), safeSaga(setGuidedOptionFilters));
}
